import type { Step, StepStatus } from './stepperTypes';

/**
 * Ermittelt den Status eines Schritts.
 *
 * Ist `currentStep` gesetzt, gewinnt die Ableitung aus dem Index und der in
 * `step.status` hinterlegte Wert wird ignoriert. Ohne `currentStep` zaehlt
 * ausschliesslich der Status am Schritt selbst.
 */
export const resolveStepStatus = (
  index: number,
  step: Step,
  currentStep: number | undefined
): StepStatus => {
  if (currentStep !== undefined) {
    if (index < currentStep) return 'completed';
    if (index === currentStep) return 'current';
    return 'upcoming';
  }
  return step.status;
};

/**
 * Gibt an, ob die Verbindungslinie nach einem Schritt gefuellt gezeichnet wird.
 *
 * Gefuellt wird sie, sobald der Schritt selbst erledigt ist oder der folgende
 * Schritt bereits begonnen hat (also nicht mehr aussteht).
 */
export const isConnectorFilled = (
  steps: Step[],
  index: number,
  currentStep: number | undefined
): boolean => {
  const step = steps[index];
  if (step && resolveStepStatus(index, step, currentStep) === 'completed') return true;

  const next = steps[index + 1];
  return next != null && resolveStepStatus(index + 1, next, currentStep) !== 'upcoming';
};
